<template>
  <Modal
    :title="$t('customize_note_block')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise` }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <InputGroup
      :label="$t('title')"
      name="title"
    >
      <TextInput
        v-model="form.title"
        name="title"
      />
    </InputGroup>

    <MarkdownInput
      v-model="form.synopsis"
      :label="$t('synopsis')"
      name="synopsis"
      rows="12"
    />

    <InputGroup
      :label="$t('image')"
      name="featured_image"
    >
      <FileInput
        v-model="form.featured_image"
        name="featured_image"
      />
    </InputGroup>

    <InputGroup
      :label="$t('url')"
      name="content_url"
    >
      <TextInput
        v-model="form.content_url"
        name="content_url"
      />
    </InputGroup>

    <InputGroup
      :label="$t('call_to_action')"
      name="call_to_action_text"
    >
      <TextInput
        v-model="form.call_to_action_text"
        name="call_to_action_text"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
import type { NoteBlock } from '~/types/blocks'

const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<NoteBlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  title: data.value.item.title,
  synopsis: data.value.item.synopsis,
  featured_image: data.value.item.featured_image,
  content_url: data.value.item.url,
  call_to_action_text: data.value.item.call_to_action_text
})
</script>
